import { SettingOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { useProgressRouter } from '@/hooks/use-progress-router';
import { useRole } from '@/hooks/use-role';
import { useScope } from '@/hooks/use-scope';

interface SettingsShortcutProps {
  isCollapsed: boolean;
}

export function SettingsShortcut({ isCollapsed }: SettingsShortcutProps) {
  const router = useProgressRouter();
  const role = useRole();
  const { organizationSlug } = useScope();
  const { t } = useTranslation();

  const handleClick = () => {
    if (role === 'org' && organizationSlug) {
      router.push(`/settings/org/${organizationSlug}/system`);
    } else {
      router.push('/settings');
    }
  };

  return (
    <Tooltip
      title={t('navigation.settings')}
      placement={isCollapsed ? 'right' : undefined}
    >
      <button
        onClick={handleClick}
        className="inline-flex cursor-pointer justify-center rounded p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-700 dark:hover:text-white"
      >
        <span className="text-2xl">
          <SettingOutlined />
        </span>
      </button>
    </Tooltip>
  );
}
